import { useLocation } from 'react-router-dom';

export function useGetState<T>(name: string): T | undefined {
  const location = useLocation();

  return location.state?.[name];
}

export default useGetState;
